module.exports = __webpack_public_path__ + "static/media/LogoMEIPresval_NavTop.211af695.svg";